import { Component, AfterViewInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthService } from '../../shared/auth.service'
import { MenuService } from './menu.service'
import { GlobService } from 'src/app/shared/glob.service'

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements AfterViewInit {
  dbmodel: any
  model: any
  // glob: any = glob

  constructor(public glob: GlobService, public authService: AuthService, private arout: ActivatedRoute, public service: MenuService) { 
    if (this.authService.menu == null) return

    this.dbmodel = this.authService.menu
    this.model = {}
    this.model.level1 = this.dbmodel.menu.filter((item: any) => item.parent_id == null)

    for (let l1 of this.model.level1) {
      l1.level2 = this.dbmodel.menu.filter((item: any) => item.parent_id == l1.id)
      for (let l2 of l1.level2) {
        l2.level3 = this.dbmodel.page.filter((item: any) => item.menu_id == l2.id)
        let temp = this.dbmodel.menu.filter((item: any) => item.parent_id == l2.id)
        for (let t of temp)
          l2.level3.push(t)
        for (let l3 of l2.level3) {
          l3.level4 = this.dbmodel.page.filter((item: any) => item.menu_id == l3.id)
          if (l3.menu_id) l3.level4 = null
          // if (l3.level4.length == 0) l3.level4 = null
        }
      }
    }
  }

  ngAfterViewInit() {}

  routa(l3) {
    return !l3.level4 ? ['/home', l3.nam || l3.id] : []
  }
  menu_item_click(){
    $('#main_menu_button > button').trigger('click')
  }
}
